<template>
  <div v-if="loading" class="d-flex justify-center mt-5">
    <v-progress-circular
      :size="200"
      :width="10"
      color="white"
      indeterminate
    ></v-progress-circular>
  </div>

  <v-container fluid grid-list-md v-else>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-dialog v-if="addDialog" v-model="addDialog" width="1000">
          <ProjectAdd
            @close="addDialog = false"
            @added="onProjectAdded"
            :fromAnnouncement="announcement"
          />
        </v-dialog>
        <AnnouncementHeader @displayFloatingWindows="displayFloatingWindows">
        </AnnouncementHeader>

        <v-card
          :class="{
            'main-panel-desktop': $mq !== 'xs' && $mq !== 'sm' && $mq !== 'md',
          }"
          class="mt-3"
        >
          <AnnouncementInfos
            :announcement="announcement"
            :edit-mode="editMode"
            :fields-getter="infosFieldsGetter"
            v-if="leftTab === 0"
          ></AnnouncementInfos>
          <v-layout row justify-end class="mx-2 pb-3">
            <v-btn
              color="secondary"
              @click="addDialog = true"
              v-if="announcement.projectId == null"
            >
              <v-icon class="mr-1">add</v-icon>
              Convertir en projet
            </v-btn>
            <v-btn
              class="mr-1"
              @click="$router.push(`/project/${announcement.projectId}`)"
              v-else
            >
              <v-icon class="mr-1">visibility</v-icon>
              Voir le projet
            </v-btn>
          </v-layout>
        </v-card>
      </v-flex>
      <v-card class="floating-window">
        <v-tabs v-model="rightTab" grow>
          <v-tab ripple><v-icon>chat</v-icon></v-tab>
          <v-tab-item>
            <Comments
              v-if="rightTab === 0"
              :target-id="announcement._id"
              :edit-mode="editMode"
            ></Comments>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-layout>

    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
  </v-container>
</template>
<script>
import Comments from "../components/comments/Comments.vue";
import { mapActions, mapState } from "vuex";
import { getInfoFields } from "../data/announcementData";
import AnnouncementInfos from "../components/announcements/AnnouncementInfos";
import AnnouncementHeader from "../components/announcements/AnnouncementHeader";
import { ANNOUNCEMENT_VALIDATION } from "../data/announcementData";
import ProjectAdd from "../components/ProjectAdd";

export default {
  components: {
    AnnouncementInfos,
    AnnouncementHeader,
    Comments,
    ProjectAdd,
  },
  timers: {
    sync: { time: 1000, autostart: true, repeat: true },
  },
  data() {
    return {
      leftTab: 0,
      rightTab: 0,
      editMode: true,
      showError: false,
      loading: true,
      showSent: false,
      showRightOnMobile: false,
      files: [],
      addDialog: false,
    };
  },

  async mounted() {
    await this.fetchAnnouncement({ id: this.$route.params.id });
    this.loading = false;
    window.addEventListener("beforeunload", this.sync);
    window.addEventListener("unload", this.sync);
  },

  beforeDestroy() {
    this.sync();
    window.removeEventListener("beforeunload", this.sync);
    window.removeEventListener("unload", this.sync);
  },

  methods: {
    ...mapActions("announcements", ["fetchAnnouncement", "syncAnnouncement"]),

    displayFloatingWindows() {
      window.document.body.classList.add("display-floating-window");
    },

    hideFloatingWindows() {
      window.document.body.classList.remove("display-floating-window");
    },

    onProjectAdded(project) {
      this.addDialog = false;
      this.announcement.projectId = project._id;
      this.syncAnnouncement();
    },

    async sync() {
      if (this.loading) {
        return;
      }
      try {
        await this.syncAnnouncement();
      } catch (e) {
        console.error(e);
        this.showError = true;
      }
    },
  },
  computed: {
    ...mapState("announcements", {
      announcement: (state) => state.current,
    }),

    infosFieldsGetter() {
      return getInfoFields;
    },

    complete() {
      let valid = true;
      for (let k of Object.keys(ANNOUNCEMENT_VALIDATION)) {
        const rules = ANNOUNCEMENT_VALIDATION[k];
        const v = this.prospect[k];
        for (const r of rules.split("|")) {
          if (r === "required") {
            valid = v !== "" && v != null;
          }
          if (r.startsWith("precise:")) {
            const [, key] = r.split(":");
            if (this.prospect[key] == null) {
              valid = false;
            }
          }
          if (!valid) {
            break;
          }
        }
        if (!valid) {
          break;
        }
      }
      return valid;
    },
  },
};
</script>
<style scoped>
.v-tabs .v-window__container {
  height: auto !important;
}

.main-panel-desktop {
  margin-right: 410px;
}
</style>
<style>
.floating-window {
  z-index: 200;
  position: fixed;
  width: 400px;
  right: 20px;
}

@media screen and (max-width: 939px) {
  .floating-window {
    width: calc(100vw - 20px);
    right: 10px;
    left: 10px;
  }
}

@media screen and (max-width: 939px) {
  .floating-window,
  .floating-window-2 {
    display: none;
  }

  .display-floating-window .floating-window,
  .display-floating-window .floating-window-2 {
    display: block;
  }
}
</style>
